import image from "./images/blue.svg"

export const logo = image
export const appTitle = "Blue"
